'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const clsx = require('clsx');
const SecondaryNav_SecondaryNavContext = require('./SecondaryNavContext.cjs.js');
const SecondaryNav_SecondaryNavItemContext = require('./SecondaryNavItemContext.cjs.js');

const secondaryNavList = "_secondary-nav-list_zkl68_1";
const styles = {
	secondaryNavList: secondaryNavList
};

const SecondaryNavList = ({ children, className }) => {
  const navItemContext = SecondaryNav_SecondaryNavItemContext.useSecondaryNavItemContext();
  const { expandedSectionKeys } = SecondaryNav_SecondaryNavContext.useSecondaryNavContext();
  const isTopLevelList = !navItemContext;
  const isHidden = isTopLevelList ? void 0 : !expandedSectionKeys.includes(navItemContext.itemId);
  return jsxRuntime.jsx("ul", { className: clsx.clsx(styles.secondaryNavList, className), "data-zds": true, hidden: isHidden, id: navItemContext === null || navItemContext === void 0 ? void 0 : navItemContext.listId, children });
};

exports.SecondaryNavList = SecondaryNavList;
//# sourceMappingURL=SecondaryNavList.cjs.js.map
